import React, { useEffect, useState } from "react";
import BasicUpload2 from "./Utils/BasicUpload2";
import useTricera from "./hooks/useTricera";
import MainHeader from "./Utils/Header";
import { readStoredJson } from "./Utils/Storage";

// to manage cart quantity in header
const baseUrl = process.env.REACT_APP_API_URL;

const ImageUpload2 = ({ setShowIcons, setcartQuantity }) => {
  const [file, setFile] = useState("");
  const { getUUID, setConfigSession } = useTricera();

  useEffect(() => {
    const storedCart = readStoredJson(localStorage, "checkoutdata");
    const hasSession = Boolean(sessionStorage.getItem("tricera-configs"));
    if (!storedCart?.cart_id) {
      if (!hasSession) localStorage.removeItem("tricera-uuid");
      setShowIcons(hasSession);
      setcartQuantity(0);
      return undefined;
    }

    const request = new AbortController();
    let active = true;
    async function fetchdata() {
      try {
        const response = await fetch(`${baseUrl}/user/cartValid`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: storedCart.cart_id }),
          signal: request.signal,
        });
        if (!response.ok) throw new Error("Cart validation failed");

        const data = await response.json();
        if (!active) return;
        const lines = data?.data?.cart?.lines?.edges;
        if (!Array.isArray(lines)) {
          setShowIcons(false);
          setcartQuantity(0);
          return;
        }

        setShowIcons(hasSession);
        setcartQuantity(
          lines.reduce((quantity, item) => quantity + Number(item?.node?.quantity || 0), 0)
        );
      } catch (error) {
        if (active && error?.name !== "AbortError") {
          setShowIcons(hasSession);
        }
      }
    }

    fetchdata();
    return () => {
      active = false;
      request.abort();
    };
  }, [setShowIcons, setcartQuantity]);

  return (
    <main className="tricera-landing">
      <div className="landing-backdrop" aria-hidden="true" />
      <section className="landing-panel" aria-label="Upload your print file">
        <h1 className="landing-title">DETAILS<br />MATTER.</h1>
        <p className="landing-intro">UPLOAD YOUR FILE TO GET STARTED.</p>
        <BasicUpload2
          setConfigSession={setConfigSession}
          getUUID={getUUID}
          setShowIcons={setShowIcons}
        />
      </section>
    </main>
  );
};
export default ImageUpload2;
